/** @jsxImportSource theme-ui */
import React, { useMemo, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Card } from '@infotrack/zenith-ui';
import type { ITopFiveApiV2EndpointsTopFiveGetTopFiveStaffTopFiveDto } from '@/api/models';
import { StaffInfoCard } from './staffInfoCard';
import { TopFiveItemsList } from './topFiveItemsList';
import { sectionStyles, cardStyles } from './topFiveCard.styles';

type TopFiveCardProps = {
  staffTopFive: ITopFiveApiV2EndpointsTopFiveGetTopFiveStaffTopFiveDto;
  selectedPeriod: 'current' | 'previous';
};

export const TopFiveCard = ({ staffTopFive }: TopFiveCardProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { staff, topFives } = staffTopFive;

  const currentTopFive = useMemo(() => {
    return topFives?.[0];
  }, [topFives]);

  // Show all available items (no limit to 5)
  const topFiveItems = useMemo(() => {
    const items = currentTopFive?.topFiveItems || [];
    return items;
  }, [currentTopFive]);

  const handleCardClick = useCallback(() => {
    const topFiveId = currentTopFive?.topFiveId;

    if (topFiveId) {
      const currentParams = new URLSearchParams(location.search);
      const detailUrl = `/topfive/${topFiveId}${currentParams.toString() ? `?${currentParams.toString()}` : ''}`;
      navigate(detailUrl);
    }
  }, [navigate, currentTopFive, location.search]);

  return (
    <Card
      borderRadius="medium"
      borderColor="neutral/200"
      boxShadow="medium"
      sx={{ ...sectionStyles, ...cardStyles }}
      role="button"
      aria-label={`View TOP 5 details for ${staff?.fullName || 'Unknown User'}`}
      padding="0"
      onClick={handleCardClick}
    >
      <StaffInfoCard staff={staff} />
      <TopFiveItemsList items={topFiveItems} onItemChange={() => {}} />
    </Card>
  );
};
